(() => {
  const SELECTOR = '[data-onda-marcas-track]';

  function initMarcasCarousel(track) {
    if (!track || track.dataset.ondaMarcasReady === 'true') return;

    const section = track.closest('.section-collection-list');
    if (!section) return;

    const previousButton = section.querySelector('[data-onda-marcas-previous]');
    const nextButton = section.querySelector('[data-onda-marcas-next]');
    const arrows = section.querySelector('[data-onda-marcas-arrows]');

    track.dataset.ondaMarcasReady = 'true';

    const getScrollStep = () => {
      const firstCard = track.querySelector('.collection-list__item');
      if (!firstCard) return 0;

      const styles = window.getComputedStyle(track);
      const gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
      return firstCard.getBoundingClientRect().width + gap;
    };

    const updateArrowState = () => {
      if (!previousButton || !nextButton || !arrows) return;

      const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
      const tolerance = 3;
      const hasOverflow = maxScroll > tolerance;

      arrows.hidden = !hasOverflow;
      previousButton.disabled = !hasOverflow || track.scrollLeft <= tolerance;
      nextButton.disabled = !hasOverflow || track.scrollLeft >= maxScroll - tolerance;
    };

    const scrollByCard = (direction) => {
      const step = getScrollStep();
      if (!step) return;
      track.scrollBy({ left: step * direction, behavior: 'smooth' });
    };

    let resizeTimer;
    let scrollTimer;

    previousButton?.addEventListener('click', () => scrollByCard(-1));
    nextButton?.addEventListener('click', () => scrollByCard(1));

    track.addEventListener(
      'scroll',
      () => {
        window.clearTimeout(scrollTimer);
        scrollTimer = window.setTimeout(updateArrowState, 60);
      },
      { passive: true }
    );

    window.addEventListener('resize', () => {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(updateArrowState, 100);
    });

    updateArrowState();
  }

  function initAll(root = document) {
    root.querySelectorAll(SELECTOR).forEach(initMarcasCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
